import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import { CATEGORY_PAWN } from "utils/constants";
import api from "_api";
import { useAuth } from "hooks/useAuth";
import { useEffect, useState } from "react";
import { useFormik } from "formik";

const ModalUploadToMarketplace = ({
  open,
  onClose,
  selectedProduct,
  fetchData,
}) => {
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const { user } = useAuth();
  const fetchPackages = async () => {
    await api.super_admin
      .getCompanyMarketPlace(user?.company_id)
      .then((res) => {
        if (res.data) {
          setPackages(res.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  };

  useEffect(() => {
    fetchPackages();
  }, []);

  useEffect(() => {
    if (!open) {
      setSelectedPackage(null);
      formik.resetForm();
    } else {
      formik.setFieldValue("product_id", selectedProduct?.product_id);
    }
  }, [selectedProduct, open]);

  const formik = useFormik({
    initialValues: {
      product_id: selectedProduct?.product_id,
      marketplace_company_id: "",
      marketplace_address: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.marketplace_company_id) {
        errors.marketplace_company_id = "กรุณาเลือกแพ็คเกจ";
      }
      return errors;
    },
    onSubmit: async (values) => {
      console.log("values", values);
      try {
        const errors = await formik.validateForm(); // บังคับ validate ก่อน submit
        if (Object.keys(errors).length > 0) {
          formik.setTouched({ marketplace_company_id: true }); // บังคับแสดงข้อผิดพลาดที่ยังไม่ได้ touch
          return;
        }

        await api.marketplace
          .sendProductToMarketPlace(values)
          .then((res) => {
            console.log("res", res);
            if (res.isStatus) {
              fetchData();
              onClose();
              formik.resetForm();
              setSelectedPackage(null);
            }
          })
          .catch((error) => {
            console.error("Error fetching product data:", error);
          });
      } catch (error) {
        console.error("Form submission error:", error);
      }
    },
  });

  const renderProduct = () => {
    return (
      <Box
        sx={{
          border: "1px solid #ddd",
          p: 2,
          mt: 1,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Table
          sx={{
            "& .MuiTableCell-root": {
              borderBottom: "none",
              fontSize: "16px",
              padding: "12px",
            },
            "& .MuiTableCell-root:first-child": {
              width: "20%",
              verticalAlign: "top",
            },
          }}
        >
          <TableBody>
            <TableRow>
              <TableCell>QR Code</TableCell>
              <TableCell>
                <QRCodeCanvas size={64} value={selectedProduct?.product_code} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>รหัสสินค้า</TableCell>
              <TableCell>{selectedProduct?.product_code}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>รหัส 2</TableCell>
              <TableCell></TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ชื่อสินค้า</TableCell>
              <TableCell>{selectedProduct?.product_name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>หมวดหมู่</TableCell>
              <TableCell>
                {
                  CATEGORY_PAWN.filter(
                    (category) => category.id === selectedProduct?.category_id
                  )[0]?.label
                }
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>รายละเอียด</TableCell>
              <TableCell>{selectedProduct?.detail}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ตำหนิ</TableCell>
              <TableCell>{selectedProduct?.blemishes}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ขนาด</TableCell>
              <TableCell>{selectedProduct?.size}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>จำนวน</TableCell>
              <TableCell>{selectedProduct?.total_amount}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ราคาทุน/ชิ้น</TableCell>
              <TableCell>{selectedProduct?.price}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ราคารวม</TableCell>
              <TableCell>{selectedProduct?.total_price}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>หมายเหตุ</TableCell>
              <TableCell>{selectedProduct?.notes}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>รูปทรัพย์</TableCell>
              <TableCell>
                {selectedProduct?.picture?.map((img, index) => (
                  <img
                    key={index}
                    src={img?.picture[0]}
                    alt={`Preview ${index}`}
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                ))}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          height: "auto",
          backgroundColor: "#F8F7FD",
        },
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle
          sx={{
            fontSize: "32px",
            fontWeight: "Regular",
          }}
        >
          ส่งสินค้าไป MarketPlace
        </DialogTitle>
        <DialogContent sx={{ padding: 4 }}>
          <Typography variant="h5">ข้อมูลสินค้า</Typography>
          {renderProduct()}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              mt: 2,
            }}
          >
            <Table
              sx={{
                "& .MuiTableCell-root": {
                  borderBottom: "none",
                  fontSize: "16px",
                  padding: "8px",
                },
                "& .MuiTableCell-root:first-child": {
                  width: "20%",
                  verticalAlign: "top",
                },
              }}
            >
              <TableBody>
                <TableRow>
                  <TableCell>ช่องทางการติดต่อ</TableCell>
                  <TableCell>
                    <TextField
                      multiline
                      rows={5}
                      sx={{
                        backgroundColor: "#ffffff",
                        width: "300px",
                      }}
                      onChange={(e) =>
                        formik.setFieldValue(
                          "marketplace_address",
                          e.target.value
                        )
                      }
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>แพ็คเกจ</TableCell>
                  <TableCell>
                    <Autocomplete
                      id="package-marketplace"
                      options={packages}
                      clearIcon={null}
                      clearOnEscape={false}
                      getOptionLabel={(option) => option.name_package}
                      getOptionKey={(option) => option.marketplace_company_id}
                      onChange={(event, newValue) => {
                        setSelectedPackage(newValue);
                        formik.setFieldValue(
                          "marketplace_company_id",
                          newValue?.marketplace_company_id
                        );
                      }}
                      onBlur={() =>
                        formik.setFieldTouched("marketplace_company_id", true)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name={`package-marketplace`}
                          fullWidth
                          helperText={
                            formik.touched.marketplace_company_id &&
                            formik.errors.marketplace_company_id
                          }
                          error={
                            formik.touched.marketplace_company_id &&
                            Boolean(formik.errors.marketplace_company_id)
                          }
                          InputProps={{
                            ...params.InputProps,
                            sx: {
                              height: "40px",
                              padding: "0px",
                              backgroundColor: "white",
                            }, // Ensure consistent height
                          }}
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>ประเภทแพ็คเกจ</TableCell>
                  <TableCell>
                    <TextField
                      fullWidth
                      InputProps={{
                        sx: {
                          backgroundColor: "white",
                          height: "40px",
                          padding: "0px",
                        },
                      }}
                      disabled
                      value={
                        selectedPackage?.package_type === "normal"
                          ? "สินค้าอื่นๆ"
                          : selectedPackage?.package_type === "popular"
                          ? "สินค้ายอดฮิต"
                          : ""
                      }
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>เครดิตคงเหลือ</TableCell>
                  <TableCell>
                    <TextField
                      fullWidth
                      disabled
                      InputProps={{
                        sx: {
                          backgroundColor: "white",
                          height: "40px",
                          padding: "0px",
                        },
                      }}
                      value={selectedPackage?.total_credit_remain}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            padding: "16px",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              width: "auto",
              borderRadius: "8px",
            }}
            onClick={onClose}
          >
            ยกเลิก
          </Button>
          <Button
            className="button-two-tone"
            sx={{ width: "auto", borderRadius: "8px", color: "white" }}
            type="submit"
            // disabled={formik.values.marketplace_company_id === ""}
          >
            ยืนยัน
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ModalUploadToMarketplace;
